var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgAddressHome = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67.65,
    height: 58.224,
    viewBox: "0 0 67.65 58.224",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(0.8 0.484)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-916 -546)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(918 548)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-24",
    d: "M7.43,24.074V52.989a1,1,0,0,0,1,1H22.949a1,1,0,0,0,1-1V36.839a6.847,6.847,0,0,1,13.693,0v16.15a1,1,0,0,0,1,1h13.9a1,1,0,0,0,1-1V24.074h0",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 3.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-25",
    d: "M0,22.869,30.486,0,62.058,22.869",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 4,
    fillRule: "evenodd"
  }))))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAddressHome, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/address-home.7634c018.svg";
export { ForwardRef as ReactComponent };